import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension, CustomFieldExtensionSchema } from '@backstage/plugin-scaffolder-react';
import { Sev2UserCombobox, Sev2UserComboboxSchema } from './Sev2UserCombobox';

export const Sev2UserComboboxFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'Sev2UserCombobox',
    component: Sev2UserCombobox,
    schema: Sev2UserComboboxSchema as CustomFieldExtensionSchema,
  }),
);
